import React from 'react';
import useTranslate from '../../../../../../../customHooks/useTranslate';

interface StatComparisonProps {
    ownText: string;
    competitorText: string;
    differenceText?: string;
    isPositive: boolean;
}

const StatComparison = ({
    ownText,
    competitorText,
    differenceText,
    isPositive,
}: StatComparisonProps) => {
    const translate = useTranslate();
    const difference = Math.abs(Number(ownText) - Number(competitorText));
    const resultClass = isPositive
        ? 'stat-result--positive'
        : 'stat-result--negative';

    return (
        <div className='flex-column gap-10'>
            <div className='flex flex-align-baseline gap-20'>
                <p
                    className={`stat-comparison--own ${
                        isPositive
                            ? 'stat-comparison--positive'
                            : 'stat-comparison--negative'
                    }`}
                >
                    {ownText}
                </p>
                <p
                    className={`stat-comparison--competitor ${
                        !isPositive
                            ? 'stat-comparison--positive'
                            : 'stat-comparison--negative'
                    }`}
                >
                    {competitorText}
                </p>
            </div>

            <p className={`stat-result ${resultClass}`}>
                {isPositive ? '+' : '-'}
                {differenceText || difference}
                {' ' + translate('vs_competitor')}
            </p>
        </div>
    );
};

export default StatComparison;
